import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import { AddCircle, DocumentDownload, Edit2, Eye, Trash } from "iconsax-react";
import CustomPagination from "../../Utils/CustomPagination";
import { useLoader } from "../../Loader";
import { useLocation } from "react-router-dom";
import ReasonModal from "../ReasonModal";
import moment from "moment";
import LogModal from "./LogModal";
import * as XLSX from "xlsx";

function List(props) {
  const [meeting, setMeetings] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const location = useLocation();
  const { startLoader, stopLoader } = useLoader();
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const handleShowModal = useCallback(
    (title, text) => () => {
      setModalTitle(title);
      setModalText(text);
      setShowModal(true);
    },
    [],
  );
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);

  const statusLabels = {
    1: "Pending",
    2: "BM Approved",
    3: "BM Amount Credited",
    4: "Received",
    5: "Not Received",
    6: "Documents Uploaded",
    7: "Final Amount By BM",
    8: "Confirm",
  };

  const columns = [
    {
      name: "EMP Id ",
      selector: (row, index) => row?.employeeId,
    },
    {
      name: (
        <div>
          Created By <br />
        </div>
      ),
      selector: (row, index) => `${row.firstName} ${row.lastName}`,
    },
    {
      name: (
        <div>
          Request Date <br />
        </div>
      ),
      selector: (row, index) => moment(row.request_date).format("DD-MM-YYYY"),
    },
    {
      name: (
        <div>
          Meeting Date <br />
        </div>
      ),
      selector: (row, index) => moment(row.meeting_date).format("DD-MM-YYYY"),
    },
    {
      name: (
        <div>
          Type of Meeting <br />
        </div>
      ),
      selector: (row, index) => row.subject_name,
    },
    {
      name: (
        <div>
          Counter Name
          <br />
        </div>
      ),
      width: "170px",
      selector: (row, index) => `${row.companyName} (${row.vendor_type})`,
    },
    {
      name: (
        <div>
          Name of Channel Partner (Retailer-Dealer/Distributor)
          <br />
        </div>
      ),
      selector: (row, index) => row.counter_name,
      width: "180px",
    },
    {
      name: "Budget",
      selector: (row, index) => row?.budget,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat ms-1 me-1"
            title="View"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>

          {utils.hasPermission(primaryMenuRes, "Meeting", "meeting.delete") && (
            <>
              {row.emp_id === userProfile?.employeeId && (
                <>
                  {row.status == "1" && (
                    <RB.Button
                      className="btn btn-flat ms-1"
                      onClick={showDelete(row)}
                    >
                      <Trash />
                    </RB.Button>
                  )}
                </>
              )}
            </>
          )}
          {/* {location.pathname === "/marketing/your-meeting-request" && (
            <>
              {utils.hasPermission(
                primaryMenuRes,
                "Your Meeting Request",
                "your_meeting.edit",
              ) && (
                <>
                  {["1", "3", "5", "9"].includes(row.status) && (
                    <RB.Button
                      className="btn-flat ms-1"
                      title="Edit"
                      onClick={handelEdit(row)}
                    >
                      <Edit2 />
                    </RB.Button>
                  )}
                </>
              )}
            </>
          )}
          {location.pathname === "/marketing/team-meeting-request" && (
            <>
              {utils.hasPermission(
                primaryMenuRes,
                "Team Meeting Request",
                "team.meeting_request_edit",
              ) && (
                <>
                  {row.status == "1" && (
                    <RB.Button
                      className="btn-flat ms-1"
                      title="Reporting Edit"
                      onClick={handelEdit(row)}
                    >
                      <Edit2 />
                    </RB.Button>
                  )}
                </>
              )}
            </>
          )}
          {location.pathname === "/marketing/meeting-request" && (
            <>
              {utils.hasPermission(
                primaryMenuRes,
                "Meeting Request",
                "brand.meeting_edit",
              ) && (
                <>
                  {(row.status == "2" ||
                    row.status == "6" ||
                    row.status == "7") && (
                    <RB.Button
                      className="btn-flat ms-1"
                      title="Brand Manager Edit"
                      onClick={handelBrand(row)}
                    >
                      <Edit2 />
                    </RB.Button>
                  )}
                </>
              )}
            </>
          )}
          {location.pathname === "/marketing/meeting-request" && (
            <>
              {utils.hasPermission(
                primaryMenuRes,
                "Meeting Request",
                "sales.meeting_edit",
              ) && (
                <>
                  {(row.status == "4" || row.status == "9") && (
                    <RB.Button
                      className="btn-flat ms-1"
                      title="Sales Person Edit"
                      onClick={handelSales(row)}
                    >
                      <Edit2 />
                    </RB.Button>
                  )}
                </>
              )}
            </>
          )} */}
        </>
      ),
    },
    {
      name: "Status",
      selector: (row, index) => statusLabels[row.status] || "Unknown",
      width: "150px",
    },
    {
      name: (
        <div>
          Meeting Request Logs <br />
        </div>
      ),
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleLogView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
    {
      name: (
        <div>
          Meeting No <br />
        </div>
      ),
      selector: (row, index) => row.meeting_no,
      width: "170px",
    },

    // {
    //   name: "Notes",
    //   selector: (row, index) => row.reporting_notes,
    //   cell: (row) => {
    //     const wordCount = row?.reporting_notes?.split(" ").length;
    //     return wordCount > 2 ? (
    //       <RB.Button
    //         className="btn btn-flat"
    //         onClick={handleShowModal("Notes", row.reporting_notes)}
    //       >
    //         <Eye />
    //       </RB.Button>
    //     ) : (
    //       <span>{row.reporting_notes}</span>
    //     );
    //   },
    // },
  ];

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.logs);
    setShowLogModal(true);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getMeetings();
  }, [page, location.pathname, primaryMenuRes, id]);

  // const routeToTypeMap = {
  //   "/marketing/your-meeting-request": "your",
  //   "/marketing/team-meeting-request": "team",
  // };

  // const type = routeToTypeMap[location.pathname] || "meeting";
  const getMeetings = () => {
    const hasBMAccess = utils.hasPermission(
      primaryMenuRes,
      "Meeting",
      "meeting.BM",
    );
    console.log(id);
    const apiUrl = hasBMAccess
      ? `/meeting/list-meeting-bm?id=${
          id ? id : ""
        }&page=${page}&per_page=${countPerPage}`
      : `/meeting/list-meeting?id=${
          id ? id : ""
        }&page=${page}&per_page=${countPerPage}`;

    utils
      .callAPI("get", apiUrl)
      .then((res) => {
        if (typeof res !== "undefined") {
          setMeetings(res);
          if (id) {
            const found = res.result.find(
              (item) => Number(item.id) === Number(id),
            );
            if (found) {
              props.onChange({
                mode: "view",
                rowData: found,
              });
            }
          }
        } else {
          setMeetings([]);
        }
      })
      .catch((err) => {
        setMeetings([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "meeting",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelBrand = useCallback((row) => async () => {
    const propdata = {
      mode: "brand",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelSales = useCallback((row) => async () => {
    const propdata = {
      mode: "sales",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/meeting/delete?id=${row?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getMeetings();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const handleDownload = () => {
    if (typeof startLoader === "function") startLoader();

    // Use BM vs default API exactly like your list loader
    const hasBMAccess = utils.hasPermission(
      primaryMenuRes,
      "Meeting",
      "meeting.BM",
    );
    const apiUrl = hasBMAccess
      ? `/meeting/list-meeting-bm?page=0&per_page=0`
      : `/meeting/list-meeting?page=0&per_page=0`;

    utils
      .callAPI("get", apiUrl)
      .then((res) => {
        if (typeof stopLoader === "function") stopLoader();

        const rows = Array.isArray(res?.result) ? res.result : [];
        if (!rows.length) {
          return Swal.fire({
            icon: "info",
            title: "No Data Found",
            text: "No meeting records available for export.",
            confirmButtonColor: "#0d6efd",
          });
        }

        // Map rows to the exact columns (order preserved by the header array below)
        const dataForExcel = rows.map((r) => ({
          "Request By": `${r.firstName || ""} ${r.lastName || ""}`.trim(),
          "Request Date": moment(r.request_date).format("DD-MM-YYYY"),
          "Meeting Date": moment(r.meeting_date).format("DD-MM-YYYY"),
          "Type of Meeting": r.subject_name || "",
          "Counter Name": r.companyName || "",
          "Name of Channel Partner (Retailer)": r.counter_name || "",
          City: r.city || "",
          State: r.state || r.state_name || "",
          "EMP Id": r.emp_id || "",

          Budget: r.budget || "",
          Reporting: `${r.rm_firstName || ""} ${r.rm_lastName || ""}`.trim(),
          "Advance Payment(Brand Amt)": r.brand_amt || "", // advance amount
          "Final Payment": r.brand_final_amt || "", // final amount
        }));

        // Ensure header order
        const headerOrder = [
          "Request By",
          "Request Date",
          "Meeting Date",
          "Type of Meeting",
          "Counter Name",
          "Name of Channel Partner (Retailer)",
          "City",
          "State",
          "EMP Id",
          "Budget",
          "Reporting",
          "Advance Payment",
          "Final Payment",
        ];

        const ws = XLSX.utils.json_to_sheet(dataForExcel, {
          header: headerOrder,
          skipHeader: false,
        });

        // Optional: set column widths
        ws["!cols"] = [
          { wch: 12 }, // Request Date
          { wch: 12 }, // Meeting Date
          { wch: 20 }, // Type of Meeting
          { wch: 28 }, // Counter Name
          { wch: 32 }, // Name of Channel Partner (Retailer)
          { wch: 16 }, // City
          { wch: 16 }, // State
          { wch: 10 }, // EMP Id
          { wch: 22 }, // EMP Name
          { wch: 12 }, // Budget
          { wch: 16 }, // Advance Payment
          { wch: 14 }, // Final Payment
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Meetings");

        const ts = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", "_")
          .replace(/:/g, "-");
        XLSX.writeFile(wb, `Meeting_List.xlsx`);
      })
      .catch((err) => {});
  };

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(
              primaryMenuRes,
              "Meeting",
              "meeting.create",
            ) && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
            <a
              href
              className={`${
                meeting.result?.length == 0 ? "disabled" : ""
              } btn btn-primary btn-circle ms-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
          </div>
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action"></div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(primaryMenuRes, "Meeting", "meeting.view") && (
              <DataTable
                columns={columns}
                data={meeting.result}
                highlightOnHover
                responsive
                pagination
                paginationServer
                paginationTotalRows={meeting.total}
                paginationPerPage={countPerPage}
                paginationComponentOptions={{
                  noRowsPerPage: true,
                }}
                paginationComponent={() => (
                  <CustomPagination
                    currentPage={page}
                    totalRows={meeting.total}
                    rowsPerPage={countPerPage}
                    onPageChange={handlePageChange}
                  />
                )}
                striped
                onChangePage={(page) => setPage(page)}
                persistTableHead
                customStyles={{
                  head: {
                    style: {
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                    },
                  },
                }}
              />
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <ReasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        text={modalText}
      />
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
    </>
  );
}

export default List;
